import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./routes/routes";
import { AppThemeProvider } from "./shared/contexts/theme.contexts";
import { LoaderProvider } from "./shared/contexts/LoaderContext";
import GlobalLoader from "./shared/layouts/GlobalLoader";
import { MenuLateral } from "./shared/components/menu-lateral/menu-lateral";
import { DrawerProvider } from "./shared/contexts/drawer.contexts";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { AuthProvider } from "./shared/contexts/auth.contexts";
import { Login } from "./shared/components/login/login.components";

const queryClient = new QueryClient();

export function App() {
  return (
    <AuthProvider>
      <AppThemeProvider>
        <LoaderProvider>
          <GlobalLoader />
          <Login>
            <DrawerProvider>
              <QueryClientProvider client={queryClient}>
                <BrowserRouter>
                  <MenuLateral>
                    <AppRoutes />
                  </MenuLateral>
                </BrowserRouter>
              </QueryClientProvider>
            </DrawerProvider>
          </Login>
        </LoaderProvider>
      </AppThemeProvider>
    </AuthProvider>
  );
}
